import { Autoplay, Navigation, Pagination, EffectFade } from "swiper";

export const newsFurtherOptions = {
  modules: [Navigation, Pagination, Autoplay, EffectFade],
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  speed: 1500,
  pagination: {
    el: ".news-swiper-pagination",
    clickable: true,
    type: "bullets",
  },
  autoplay: false,
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 60,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 85,
    },
  },
}